import createReducer from 'utils/createReducer';

const driverInfoInitialState = {
  opened: false,
  loading: false,
  driverData: null,
  positionData: null,
  error: null,

  asigning: false,
  assignDone: false,
  assignError: null,
};

// Initial State
const INIT_STATE = {
  data: null,
  idType: '',
  positions: [],
  fetching: {
    positions: false,
  },
  driverInfo: {
    ...driverInfoInitialState,
  },
};

// Actions
const SET_OPENED = 'journey-map/SET_OPENED';
const SET_DATA = 'journey-map/SET_DATA';
const SET_POSITIONS = 'journey-map/SET_POSITIONS';
const SET_FETCHING = 'journey-map/SET_FETCHING';
const SET_DRIVER_INFO = 'journey-map/SET_DRIVER_INFO';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_OPENED](state, { opened, idType }) {
    return {
      ...state,
      opened,
      idType,
    };
  },
  [SET_POSITIONS](state, positions) {
    return {
      ...state,
      positions,
    };
  },
  [SET_DATA](state, data) {
    return {
      ...state,
      data,
      opened: !!data,
      idType: data ? state.idType : '',
    };
  },
  [SET_FETCHING](state, { model, fetching }) {
    return {
      ...state,
      fetching: {
        [model]: fetching,
      },
    };
  },
  [SET_DRIVER_INFO](state, payload) {
    return {
      ...state,
      driverInfo: {
        ...state.driverInfo,
        ...payload,
      },
    };
  },
});

export const setData = (payload) => ({
  type: SET_DATA,
  payload,
});

export const setOpened = (payload) => ({
  type: SET_OPENED,
  payload,
});

export const setPositions = (payload) => ({
  type: SET_POSITIONS,
  payload,
});

export const setFetching = (payload) => ({
  type: SET_FETCHING,
  payload,
});

export const setDriverInfo = (payload) => ({
  type: SET_DRIVER_INFO,
  payload,
});

export { driverInfoInitialState };
